//PaymentRecieveReport
import React, { useState, useEffect , useRef} from "react";
import axios from 'axios';
import { aPIURL } from '../utils/common';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useReactToPrint } from 'react-to-print';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const PaymentRecieveReport =()=>
{
    
    const [customerData, setCustomerData]= useState([]);   
    const API_URL=aPIURL();
    const [rptDate,setRptDate]=useState();
    let [custID, setCustID]=useState(0);
    let [min_Date,setMin_Date]= useState("");
    let [max_Date,setMax_Date]= useState("");
    const [order, setOrder] = useState("ASC");
    const [sdate,setSdate] = useState();
    const [edate,setEdate] = useState();     
    const [post, setPost] = useState([]);
    const fileType ="xlsx";
    const tableRef = useRef(null);
    const [totalReceiveAmt,setTotalReceiveAmt]=useState(0);
    
useEffect(() => {

    getSevenDaysAgoDate();
    const curls=API_URL+`GpsSaleCustomerList/`;     
    axios.post(curls).then(response => {        
          setCustomerData(response.data.data);                       
    }).catch(function(error) { console.log(error.message); });          
  }, []);

  const SetReportDate=()=>{
              //set today date as default date starts
                var now = new Date();
                var month = (now.getMonth() + 1);               
                var day = now.getDate();
                if (month < 10) 
                month = "0" + month;
                if (day < 10) 
                day = "0" + day;
                var today = day + '-' + month + '-' + now.getFullYear();
                var endDate = now.getFullYear() + '-' + month + '-' + day;
                setRptDate(today);               

}             
const getSevenDaysAgoDate = () => 
 {
     SetReportDate();
    const date = new Date();
    date.setDate(date.getDate() - 700);
    setMin_Date(date.toISOString().split('T')[0]);
    const mdate = new Date();
    mdate.setDate(mdate.getDate());
    setMax_Date(mdate.toISOString().split('T')[0]);

    //set today date as default date starts
    var now = new Date();
    var month = (now.getMonth() + 1);               
    var day = now.getDate();
    if (month < 10) 
    month = "0" + month;
    if (day < 10) 
    day = "0" + day;
    var today = now.getFullYear() + '-' + month + '-' + day;
    setSdate(today);
    setEdate(today); 
 };

const ChangeCustomerID = (e) => 
{
    setCustID(e.target.value);      
}
const sorting=(col)=>
{
    try
    {
      if(order==="ASC")
      {
              const sorted=[...post].sort((a,b)=>
              a[col].toLowerCase() > b[col].toLowerCase() ? 1: -1);
              setPost(sorted);
              setOrder("DSC");
      }
      if(order==="DSC")
      {
              const sorted=[...post].sort((a,b)=>
              a[col].toLowerCase() < b[col].toLowerCase() ? 1: -1);
              setPost(sorted);
              setOrder("ASC");
      }
    }
    catch(error) 
    {
      console.log(error.message);
    }             
}

const ResetList=()=>
{
      getSevenDaysAgoDate();
      setPost([]);
      setCustID(0);         
}
const SDatechangeHandler = (e) => 
{   
    setSdate(e.target.value);    
} 
const EDatechangeHandler = (e) => 
{   
    setEdate(e.target.value)
}

const SearchBtnClick=()=>
{
    
      let invnourl = API_URL+`GetPaymentRecieveReport?acid=${custID}&fdt=${sdate}&tdt=${edate}`;
      axios.get(invnourl).then(response => 
      {
            if(response.data.data.length>0)
            {
                      setTotalReceiveAmt(response.data.data[0].totalReceiveAmt);
                      setPost(response.data.data);                     
            } 
            else
            {
                    setPost([]);
                    toast.error("No Data Found..");      
            }          
        }).catch(function(error) 
        { 
            toast.error("No Data Found..");  
            console.log(error.message); 
        });   
                                  
       
}
const exportToCSV=()=>
{
       const newPost = post.map(({ tInvoiceAmt,tOutstandingAmt,tReceiveAmt,type,accountID,totalReceiveAmt, ...rest }) => rest);
       const ws= XLSX.utils.json_to_sheet(newPost);        
       var wscols = [
          {wch:10},{wch:20},{wch:20},{wch:20},{wch:20} ,{wch:20}, {wch:20}, {wch:20}, {wch:20}
      ];
   
      var wsrows = [
            {hpx: 30}
      ];
      
      ws['!cols'] = wscols;
      ws['!rows']=wsrows;
           
      let Heading = [['S.No.','Customer Name','Invoice No','Receipt No','Receipt Date','Payment Mode','Reference No','Received By','Amount']];
      const wb={Sheets:{PaymentReceive:ws},SheetNames:["PaymentReceive"]};
      XLSX.utils.sheet_add_aoa(ws, Heading);     
      const excelBuffer= XLSX.write(wb,{bookType:"xlsx",type:"array"});
      const data= new Blob([excelBuffer],{type:fileType});
      FileSaver.saveAs(data,"PaymentReceive"+".xlsx");
     }

const exportDownload = e => 
{  
  const value = e.target.value;   
  if(value==="Excel")
  {
        exportToCSV();   
  }
  if(value==="PDF")
  {
        handlePrint(null, () => tableRef.current);
  }
}

const handlePrint = useReactToPrint({
  documentTitle: "Paymentreceive",
  onBeforePrint: () => console.log("before printing..."),
  onAfterPrint: () => console.log("after printing..."),
  removeAfterPrint: true,
});

return(
<>  
   <div className="top-bar clearfix">
    <div className="row">
    <div className="col-md-4">
    <h2> Payment Receive Report </h2>             
    </div>
    <div className="col-md-8 text-right">                    
    <select onChange={exportDownload} className="btn btn-primary" name="Download" >
    <option value={"Download"}>Download</option>    
    <option value={"Excel"}>Excel</option>    
    <option value={"PDF"}>PDF</option>                      
    </select>
    </div>
    </div>
    </div>         
    <div className="container-fluid p-3">
    <div class="card mb-3 shadow no-border border-0">
    <div class="card-body">
    <div class="row align-items-end">  
    <div class="col-sm-1 col-lg-1" style={{textAlign:"right"}}>
    Customer <span style={{color:"red"}}>&nbsp;*</span>
    </div>  
    <div className='col-md-3 col-lg-3'>     
    <select className="form-control"  name="DCustomerID" value={custID} onChange={ChangeCustomerID} >
    <option value={0}>------ Select Customer ------</option>
    {customerData.map((e, key) => {
    return <option key={key} value={e.accountID}>{e.customerName}</option>;
    })}
    </select>
    </div>
    <div class="col-sm-1 col-lg-1" style={{textAlign:"right"}}>
   From Date 
   </div>  
   <div class="col-sm-2 col-lg-2">   
   <input class="form-control" aria-label="SDate" onChange={SDatechangeHandler} value={sdate} min={min_Date} max={max_Date} type="date" />
   </div>
   <div class="col-sm-1 col-lg-1" style={{textAlign:"right"}}>
   To Date
   </div>  
   <div class="col-sm-2 col-lg-2">   
   <input class="form-control" aria-label="EDate" onChange={EDatechangeHandler} value={edate} min={min_Date} max={max_Date} type="date" />
   </div>             
   <div class="col-sm-2 col-lg-2"> 
   <button id="btnSearchNew" className="btn btn-primary2" onClick={() => SearchBtnClick()}>Search</button>  
    <button id="btnResetNew" type="button" class="btn btn-secondary mt-20" onClick={ResetList}>Reset
    </button> 
    </div>      
   
    </div></div></div>     
 <div className="container-fluid p-3">
    <div class="card mb-3 shadow no-border border-0">
    <div ref={tableRef} style={{ padding:"25px"}} class="card-body">    
    <div class="row align-items-end">  
      <span style={{ textAlign:'center',fontSize:"18px" }}><b>Payment Receive Report</b> </span>
    <span style={{ textAlign:'right' }}>DATE : { rptDate }</span>    
  <table  id="example" class="table table-striped table-bordered table-hover" style={{width:"98%", marginTop:"20px", marginLeft:"10px",marginRight:"10px" }}>
  <thead>
  <tr><th style={{textAlign:"center"}} width="5%">S.No. </th>  
             <th onClick={()=>sorting("createdBy") } width="20%" style={{textAlign:"center","cursor": "pointer" }}>Customer Name &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>  
             <th onClick={()=>sorting("invoiceID") } width="10%" style={{textAlign:"center","cursor": "pointer"}}>Invoice No &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>  
             <th onClick={()=>sorting("receiptDate") } width="10%" style={{textAlign:"center","cursor": "pointer"}}>Receipt Date &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
             <th onClick={()=>sorting("pModeID") } width="10%" style={{textAlign:"center","cursor": "pointer"}}>Payment Mode &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
             <th onClick={()=>sorting("reference") } width="10%" style={{textAlign:"center","cursor": "pointer"}}>Reference No &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
             <th onClick={()=>sorting("receivedBy") } width="15%" style={{textAlign:"center","cursor": "pointer"}}>Received By &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th> 
              <th onClick={()=>sorting("receiveAmt") } width="10%" style={{textAlign:"center","cursor": "pointer"}}>Amount &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i> </th>            
  </tr>
  </thead>
  <tbody>
            {post.map((pdata) => {
            return (                  
            <tr key={pdata.id}>
              <td style={{textAlign:"center"}}>{pdata.id}</td> 
              <td>{pdata.createdBy}</td>                 
              <td>{pdata.invoiceID}</td>             
              <td style={{textAlign:"center"}}>{pdata.receiptDate}</td>              
              <td style={{textAlign:"center"}}>{pdata.pModeID}</td>             
              <td>{pdata.reference}</td>
              <td>{pdata.receivedBy}</td>  
              <td style={{textAlign:"right"}}>{pdata.receiveAmt}</td>              
            </tr>); })} 
  </tbody></table>    
    <span style={{ textAlign:'right' }}><b> Total Amount : &nbsp;{ totalReceiveAmt }</b></span> 
  </div> </div></div></div> </div>
  <ToastContainer position="bottom-right" autoClose={4000} theme="light"/>           
  </>
); }   
export default PaymentRecieveReport;
